// extracted by mini-css-extract-plugin
export default {"sidebarBasic":"sidebarBasic__53i4kjM","sidebar":"sidebar__8+0uvKz","sidebarInner":"sidebarInner__Sq5vTwz","accordionTitle":"accordionTitle__EZ0Pib0"};